<template>
  <BreadCrumb PageTitle="Account Settings" />
  <CoverImage />
  <TransportSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Generals/CoverImage.vue";
import TransportSettings from "../../components/Generals/AccountSettings/TransportSettings.vue";

export default defineComponent({
  name: "TransportsPage",
  components: {
    BreadCrumb,
    CoverImage,
    TransportSettings,
  },
}); 
</script>